module.exports = __webpack_public_path__ + "img/got.dff23fde.png";